module.exports = __webpack_public_path__ + "img/how_shop_6.04c89f66.png";